import * as React from 'react';
import { ConfigurationModel, TroughModel } from 'franke-trough-dependencies';
import { GlobalPrivateState, QueryParemeterPayload, ActiveFilterValue, checkIfTroughIsActive } from 'src/api';
import TroughAdd from '../TroughAdd/TroughAdd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfo } from '@fortawesome/free-solid-svg-icons';

import './TroughListItem.scss';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { RequestApiResult } from 'loopback-react-request';
import classNames from 'classnames';
import TroughImage from '../TroughImage/TroughImage';

import { FormattedMessage } from 'react-intl';
import MESSAGES from './TroughListItem.messages';

export interface TroughListItemProps {
  activeFilters?: ActiveFilterValue[];
  configuration: RequestApiResult<ConfigurationModel>;
  disable: boolean;
  params: QueryParemeterPayload;
  trough: TroughModel;
  troughId: string;
}

export interface TroughListItemState {
  selected: boolean;
}

export class TroughListItemPartial extends React.Component<TroughListItemProps, TroughListItemState> {
  constructor(props: TroughListItemProps) {
    super(props);
    this.state = {
      selected: false,
    };
  }

  public render() {
    const {configuration, trough } = this.props;
    const configurationId = configuration && configuration.result && configuration.result.id;

    const unavailableTroughs = ['EXOS', 'EXOSBF', 'MEDCARE', 'MEDCAREBF', 'MEDCAREBFOF', 'MEDCAREBFS', 'MEDCAREBFSOF', 'MEDCAREBFSOF', ];
    
    return (
      <div 
        className={classNames(
          'partial-trough-list-item',
          'col-12 col-md-12 col-lg-12 col-xl-4', {
            'active': this.active,
          }
        )}
      >
        <div className="trough-list-item-inner border-bottom pb-2">
          <div className="row">
            <div className="col-12 trough-heading pt-4 pb-2">
              <div className="row">
                <div className="col-10 text-left d-flex">
                  <h6>{trough.name}</h6>
                  {/*unavailableTroughs.includes(trough.sapName) && (
                    <span className="warning"><FormattedMessage {...MESSAGES.troughListItemUnavailable} /></span>
                  )*/}
                </div>
                <div className="col-2 text-right">
                  <Link 
                    to={`/configuration/${configurationId}/trough/${trough.id}`}
                    title={trough.name}  
                  >
                    <FontAwesomeIcon icon={faInfo} />
                  </Link>
                </div>
              </div>
            </div>

            <div className="col-4 trough-image">
              <div className="row">
                <div className="col-12">
                  <img src={`https://kwcws3d.blob.core.windows.net/cdn/images/troughs/${trough.fileName}.png`} className="img-fluid" alt={trough.name} />
                </div>
              </div>
              <TroughAdd troughId={trough.id} />
            </div>

            <div className="col-8 trough-data">
              <div className="row">
                <div className="col-6 col-md-4 text-left">
                  <small><FormattedMessage {...MESSAGES.troughListItemWidth} /></small>
                  <p>{trough.throughWidth} mm</p>
                </div>
                <div className="col-6 col-md-4 text-left">
                  <small><FormattedMessage {...MESSAGES.troughListItemHeight} /></small>
                  <p>{trough.throughHeight} mm</p>
                </div>
                <div className="col-6 col-md-4 text-left">
                  <small><FormattedMessage {...MESSAGES.troughListItemDepth} /></small>
                  <p>{trough.throughDepth} mm</p>
                </div>
                <div className="col-12 col-md-12 text-left">
                  <small><FormattedMessage {...MESSAGES.troughListItemMinDimensions} /></small>
                  <p>{trough.minPlateWidth} mm x {trough.plateDepth.min} mm</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  private get active(): boolean {
    const { activeFilters, trough } = this.props;
    if (!activeFilters) {
      return false;
    }
    return checkIfTroughIsActive(trough, activeFilters);
  }
}

export const TroughListItem = connect((state: GlobalPrivateState) => ({
  configuration: state.configuration,
  params: state.queryState.params,
}))(TroughListItemPartial);

export default TroughListItem;
